// extracted by mini-css-extract-plugin
module.exports = {"creator":"styles_creator__35vGJ"};